import React from 'react';
import { ModalDialog, Heading } from '@zillow/constellation';
import styled from 'styled-components';
import { SourcePage } from './types/compose-types';

export interface ZoomPageProps {
  isOpen: boolean;
  page: SourcePage;
  onClose: () => void;
}

const PageImage = styled.img<{ pageWidth: number }>`
  width: ${props => props.pageWidth}px;
`;

function ZoomPageModal(props: ZoomPageProps) {
  const { page, ...rest } = props;
  let pageImageUrl = page.pageImage.url;

  if (page.rotation > 0) {
    pageImageUrl += `&rotation=${page.rotation}`;
  }

  return (
    <ModalDialog
      {...rest}
      wide
      header={<Heading level={6}>Page {page.pageNumber}</Heading>}
      body={<PageImage src={pageImageUrl} pageWidth={page.width} />}
    />
  );
}

export default ZoomPageModal;
